import React from "react";
import "./Contact.css";

const links = [
  { label: "LinkedIn", href: "https://www.linkedin.com/in/kashish-shukla-dev/" },
  { label: "GitHub", href: "https://github.com/Kashish-Shukla18" },
  { label: "GitLab", href: "https://gitlab.com/kashish.shukla.8076" },
];

function Contact() {
  return (
    <section id="contact" className="contact section-band">
      <div className="section-inner">
        <div className="contact__inner">
          <header className="section-header section-header--center">
            <div className="section-label">Contact</div>
            <h2 className="section-title">
              Let's Build <em>Something</em>
            </h2>
            <p className="section-subtitle">
              Actively seeking React Developer / Full Stack roles, including remote.
              Reach out via email, phone, or LinkedIn.
            </p>
          </header>

          <div className="contact__details">
            <a href="mailto:kashish.shukla.8076@gmail.com" className="contact__detail ui-card ui-card--flat">
              <span className="contact__detail-label">Email</span>
              <span className="contact__detail-value">kashish.shukla.8076@gmail.com</span>
            </a>
            <a href="tel:+917007849495" className="contact__detail ui-card ui-card--flat">
              <span className="contact__detail-label">Phone</span>
              <span className="contact__detail-value">+91 70078 49495</span>
            </a>
          </div>

          <div className="contact__actions">
            <a
              href="https://www.linkedin.com/in/kashish-shukla-dev/"
              target="_blank"
              rel="noreferrer"
              className="btn-primary"
            >
              Connect on LinkedIn
            </a>
            <a
              href="mailto:kashish.shukla.8076@gmail.com"
              className="btn-outline"
            >
              Send Email
            </a>
          </div>

          <div className="contact__links">
            {links.map(({ label, href }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                className="ui-chip ui-chip--link"
              >
                {label} ↗
              </a>
            ))}
          </div>

          <blockquote className="contact__quote ui-card ui-card--flat">
            "First, solve the problem. Then, write the code."
          </blockquote>

          <footer className="contact__footer">
            Designed & built by{" "}
            <span className="contact__name">Kashish Shukla</span> · {new Date().getFullYear()}
          </footer>
        </div>
      </div>
    </section>
  );
}

export default Contact;
